
import React, { useState, useEffect, useContext } from 'react';
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton, useRelationshipInjector, useFormatter } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks";

import JSONPretty from 'react-json-pretty'

const dataProviderName = 'imports/job';
const drawerRouteBase = 'imports';

const Detail_v1 = (params) => {
    const { t } = useTranslation();
    const { close: closeDrawer } = useDrawer();
    const { userCapabilities } = useContext(AppContext);

    // DATA PROVIDER
    const { item, save, loadOne, destroy, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);
    useLoadOne({ loadOne, params, reloadCounter })

    const detailConfig = {
        "tabs": [
            {
                "name": "import",
                "fieldsets": [
                    {
                        "name": "status",
                        "fields": {
                            "id": {
                                "type": "text",
                                "className": "col-4"
                            },
                            "created_at": {
                                "type": "text",
                                "className": "col-4"
                            },
                            "updated_at": {
                                "type": "text",
                                "className": "col-4"
                            },
                            "dataTotal": {
                                "type": "text",
                                "className": "col-6"
                            },
                            "dataImported": {
                                "type": "text",
                                "className": "col-6"
                            },
                        }
                    },
                    {
                        "name": "errors_in_import",
                        "fields": {
                            "error": {
                                "type": "mapping",
                                "className": "col-12",
                                "datakey": "error"
                            },
                        },
                        "visibilitycondition": [
                            [
                                "error",
                                "isNotEmpty",
                                "true"
                            ]
                        ]
                    },
                    {
                        "name": "mapping",
                        "fields": {
                            "mapping": {
                                "type": "mapping",
                                "className": "col-12",
                                "datakey": "mapping"
                            },
                        }
                    },
                    {
                        "name": "data",
                        "fields": {
                            "data": {
                                "type": "previewexceldata",
                                "className": "col-12"
                            },
                        }
                    },
                ]
            }
        ]
    }

    const [editing, setEditing] = useState(false)

    const handleSave = (data) => {
        save({ ...data, filters: params.filters /*, canReloadCounter:false*/ }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const [confirmDelete, setConfirmDelete] = useState();
    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={() => {
                    destroy && destroy(id);
                    closeDrawer();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Item elimination")}>
                {t("Are you sure to remove this element?")}
            </Confirm>
        );
    }

    return (
        <>
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    ...item?.data,
                    data: item?.data?.excelData
                }}
                modelName={'import'}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                title={item?.data?.import_file}
                subtitle={item?.data?.status}
                rightButtons={[
                    <SplitButton
                        actions={[
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                icon: "faTrash",
                                label: t('Delete'),
                                onClick: () => { handleDelete(item.data.id); }
                            }
                        ]}
                    />
                ]}
                {...params}
            />

            {confirmDelete}
        </>
    )
}

export default Detail_v1;


